import { useEffect, useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const buildQuery = ({ page, perPage, filters, sortBy, sortDir }) => {
  const params = new URLSearchParams();
  params.set("page", String(page + 1));
  params.set("per_page", String(perPage));

  if (sortBy) params.set("sort_by", sortBy);
  if (sortDir) params.set("sort_dir", sortDir);

  if (filters.assignStatus) params.set("assign_status", filters.assignStatus);
  if (filters.user) params.set("user_q", filters.user.trim());
  if (filters.questionnaireSearch) params.set("questionnaire_q", filters.questionnaireSearch.trim());
  if (filters.context) params.set("context_q", filters.context.trim());
  if (filters.aqExternalId) params.set("aq_external_id_q", filters.aqExternalId.trim());
  if (filters.questionnaireType) params.set("questionnaire_type", filters.questionnaireType);
  if (filters.questionnaireStatus) params.set("questionnaire_status", filters.questionnaireStatus);

  // El filtro "desde" aplica a activation_window_start
  if (filters.windowFrom) params.set("start_from", filters.windowFrom);
  // El filtro "hasta" aplica a activation_window_end
  if (filters.windowTo) params.set("end_to", filters.windowTo);

  return params.toString();
};

const useFetchApplicationAssignments = (appId, { page, perPage, filters, sortBy, sortDir }) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook({ application: null, assignments: [], meta: null });
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = useCallback(async () => {
    if (!appId) return null;
    startLoading();

    const qs = buildQuery({ page, perPage, filters, sortBy, sortDir });
    const response = await apiGet(`/aplicaciones/${appId}/assignments_report?${qs}`, "Error al obtener las asignaciones de la aplicación");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appId, page, perPage, filters, sortBy, sortDir]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchApplicationAssignments;
